import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-navy" data-id="element-58" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-59" data-mp="c4fwsneah3rv">
        <h2 id="cierre" className="font-display text-[1.75rem] leading-none text-brand-yellow sm:text-5xl" data-id="element-60" data-mp="83vw59uibi0z">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-61" data-mp="h52hpxc0jj13">
          Podés seguir buscando videos, experimentos y manualidades sin saber qué
          actividad preparar primero. O podés comenzar hoy a ofrecerles a tus
          hijos una colección organizada de proyectos para construir, descubrir y
          aprender jugando.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-bold leading-snug text-white" data-id="element-62" data-mp="zwvabqn6728a">
          No necesitás ser experto en ciencia para acompañar a un pequeño
          inventor. <span className="text-brand-yellow" data-id="element-63" data-mp="2h3rh2jb4vhf8">Solo necesitás dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-brand-orange bg-white p-3 text-brand-navy" data-id="element-64" data-mp="2m2ubzaxeg79h">
          <p className="font-sans text-sm font-extrabold uppercase leading-tight text-brand-blue" data-id="element-65" data-mp="2r2gofi5eljh8">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-3xl leading-none" data-id="element-66" data-mp="2v2zfvb3dwniw">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-brand-muted sm:text-sm" data-id="element-67" data-mp="300sk3yl4n7gj">
            Valor de los bonos:{' '}
            <span className="line-through decoration-2" data-id="element-68" data-mp="34vohzfd1op1k">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-6xl leading-none text-brand-green sm:text-7xl" data-id="element-69" data-mp="39uhx1c7zco3u">
            <span className="text-3xl text-brand-navy sm:text-4xl" data-id="element-70" data-mp="3epf2ya9yqhci">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-71" data-mp="1joczkidfp7yn">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-brand-muted" data-id="element-72" data-mp="1eq1rac2sf5ij">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}